import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Headset, Settings2, ArrowLeft } from 'lucide-react';
import { jarvis } from './api';
import Operador from './Operador';
import Supervisor from './Supervisor';
import './jarvis.css';

// Zaping (antes "Teste Jarvis"): atendimento por WhatsApp (QR code) dentro do Quality.
// Escolha de entrada: Operador (conversas) ou Supervisor (configurações e monitoramento).
export default function TesteJarvis() {
  const [params, setParams] = useSearchParams();
  const modo = params.get('modo');
  const [eu, setEu] = useState(null);
  const [erro, setErro] = useState('');

  useEffect(() => { jarvis('eu').then(setEu).catch(e => setErro(e.message)); }, []);

  if (erro) return <div className="jv-pagina"><div className="jv-aviso jv-aviso-erro">{erro}</div></div>;
  if (!eu) return <div className="jv-pagina"><div className="jv-carregando">Carregando…</div></div>;

  const voltar = (
    <button className="jv-voltar" onClick={() => setParams({})}><ArrowLeft size={16} /> Zaping</button>
  );

  if (modo === 'operador') return <Operador eu={eu} voltar={voltar} />;
  if (modo === 'supervisor' && eu.supervisor) return <Supervisor eu={eu} voltar={voltar} />;

  return (
    <div className="jv-pagina jv-inicio">
      <div className="jv-inicio-cab">
        <div className="jv-logo">J</div>
        <div>
          <h1>Zaping</h1>
          <p>Atendimento por WhatsApp dentro do Quality · olá, {eu.nome}</p>
        </div>
      </div>
      <div className="jv-escolha">
        <button className="jv-cartao-escolha" onClick={() => setParams({ modo: 'operador' })}>
          <Headset size={44} />
          <strong>Operador</strong>
          <span>Atender as conversas do WhatsApp: fila de espera, chat, textos prontos, transferir e encerrar.</span>
        </button>
        <button className="jv-cartao-escolha" disabled={!eu.supervisor} onClick={() => setParams({ modo: 'supervisor' })}
          title={eu.supervisor ? '' : 'Só o supervisor acessa'}>
          <Settings2 size={44} />
          <strong>Supervisor</strong>
          <span>{eu.supervisor
            ? 'Conectar o WhatsApp, filas e atendentes, robô de entrada, horários, textos prontos, monitoramento e relatórios.'
            : 'Acesso só para supervisores.'}</span>
        </button>
      </div>
    </div>
  );
}
